import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useState } from "react";
import { FlowOutput, Upload } from "../../graphql/types";
import { UploadRow } from "../UploadRow";
import { DateCol, StatusTh } from "../ui/muiTables";

type UploadTableProps = {
  uploads: Array<Upload> | Array<FlowOutput>;
  allowViewDownloads?: boolean;
};

const UploadTable = ({ uploads, allowViewDownloads = true }: UploadTableProps) => {
  const [rowSelected, setRowSelected] = useState<string | null>(null);

  const handleRowSelected = (id: string) => {
    if (id && id === rowSelected) {
      setRowSelected(null);
    } else {
      setRowSelected(id);
    }
  };

  const rows = uploads.map((u: Upload | FlowOutput) => {
    return (
      <UploadRow
        key={u.id}
        allowViewDownloads={allowViewDownloads}
        onClick={handleRowSelected}
        upload={u}
        showDetail={rowSelected === u.id}
      />
    );
  });

  return (
    <TableContainer component={Paper} sx={{ width: "100%", minWidth: "fit-content" }}>
      <Table className="table-striped table-condensed" stickyHeader data-cy="uploads-table">
        <TableHead>
          <TableRow>
            <DateCol>Report Date</DateCol>
            <DateCol>Ready</DateCol>
            <DateCol>Started</DateCol>
            <DateCol>Finished</DateCol>
            <TableCell>Description</TableCell>
            <TableCell>Destination</TableCell>
            <TableCell></TableCell>
            <StatusTh>Status</StatusTh>
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    </TableContainer>
  );
};

export { UploadTable };
export type { UploadTableProps };
